import { render, staticRenderFns } from "./Forms.vue?vue&type=template&id=7f40ba36&scoped=true&"
import script from "./Forms.vue?vue&type=script&lang=js&"
export * from "./Forms.vue?vue&type=script&lang=js&"
import style0 from "./Forms.vue?vue&type=style&index=0&id=7f40ba36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f40ba36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-extranet/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f40ba36')) {
      api.createRecord('7f40ba36', component.options)
    } else {
      api.reload('7f40ba36', component.options)
    }
    module.hot.accept("./Forms.vue?vue&type=template&id=7f40ba36&scoped=true&", function () {
      api.rerender('7f40ba36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Forms.vue"
export default component.exports